// components
import Modal, { ModalProps } from "@/shared/Modal";

// assets
import styles from "@/assets/styles/components/Modals/video-modal.module.scss";

// ModalProps
function VideoModal({ open, onCancel, ...props }: ModalProps) {
  return (
    <Modal
      centered
      open={open}
      onCancel={onCancel}
      footer={null}
      className={styles["locl-video-modal"]}
      destroyOnClose
      {...props}
    >
      {open && (
        <div className={styles["locl-video-modal__container"]} data-testid="locl-video-modal-container">
          <video
            className={styles["locl-video-modal__video"]}
            autoPlay
            loop
            playsInline
            controls
            preload="none"
          >
            <source
              className="embed-responsive-item"
              src="https://d7lpf28obzvlg.cloudfront.net/etc/LL+Demo+0805+vFINAL.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      )}
    </Modal>
  );
}

export default VideoModal;
